import { Inject, LOCALE_ID, Pipe, PipeTransform } from "@angular/core";

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Grober Abstand zu jetzt: "vor 3 Monaten", "vor 2 Wochen".
 *
 * ⚠ Bewusst ungenau — die groesste passende Einheit gewinnt und wird gerundet.
 * Fuer den genauen Zeitpunkt steht das Datum daneben.
 */
@Pipe({
  name: "relativeTime",
  standalone: false,
})
export class RelativeTimePipe implements PipeTransform {
  /** Schwellen absteigend: die erste passende Einheit wird verwendet. */
  private static readonly UNITS: Array<[Intl.RelativeTimeFormatUnit, number]> =
    [
      ["year", 365 * DAY],
      ["month", 30 * DAY],
      ["week", 7 * DAY],
      ["day", DAY],
      ["hour", HOUR],
      ["minute", MINUTE],
    ];

  constructor(@Inject(LOCALE_ID) private _locale: string) {}

  public transform(
    value: string | number | Date | null | undefined,
    now: number = Date.now(),
  ): string {
    if (!value) {
      return "";
    }

    const time = new Date(value).getTime();

    if (Number.isNaN(time)) {
      return "";
    }

    const elapsed = time - now;
    // ⚠ numeric "always": mit "auto" kaemen "gestern" und "letztes Jahr"
    // heraus und die Liste mischte zwei Formen. "letztes Jahr" waere zudem
    // mehrdeutig (Kalenderjahr vs. zwoelf Monate her).
    const format = new Intl.RelativeTimeFormat(this._locale, {
      numeric: "always",
    });

    for (const [unit, size] of RelativeTimePipe.UNITS) {
      if (Math.abs(elapsed) >= size) {
        return format.format(Math.round(elapsed / size), unit);
      }
    }

    // ⚠ Unter einer Minute: Sekunden statt "vor 0 Minuten". Auf mindestens
    // eine Sekunde gerundet, damit nicht "vor 0 Sekunden" dasteht.
    const seconds = Math.round(elapsed / 1000);

    return format.format(seconds === 0 ? -1 : seconds, "second");
  }
}
